module.exports = __webpack_public_path__ + "17cb8593cceaa85615120e9b8e3c4400.png";